import { Box, Stack, Typography, styled } from '@mui/material';
import Button from '@ui/Button';
import Search from '@ui/Search';
import { authorizedServerFetch } from 'actions/server.actions';
import { isEmpty } from 'lodash-es';
import React, { useEffect } from 'react';
import CommunityItem from './CommunityItem';

const CardContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  padding: theme.spacing(0.5),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

function EditProfileNpoStep(props) {
  const { userProfile, onSubmit, onBack, formData, onNext, onChange } = props;

  const [recommendedCommunity, setRecommendedCommunity] = React.useState([]);
  const [preferredCommunity, setPreferredCommunity] = React.useState([]);
  const [selectedCommunity, setSelectedCommunity] = React.useState([]);
  const [searchedCommunity, setSearchedCommunity] = React.useState([]);

  useEffect(() => {
    const fetchRecommendedCommunity = async () => {
      try {
        // change the api endpoint later
        let { data } = await authorizedServerFetch('nonprofits/recommended');
        data = data.data;
        console.log('data', data);
        if (!isEmpty(data)) {
          setRecommendedCommunity(data.recommended);
          setPreferredCommunity(data.preferred);
        }
      } catch (err) {
        console.log('error', err);
      }
    };
    // fetchRecommendedCommunity(); // need to create api for the same in backend
  }, []);

  const handleAddCommunity = (community) => {
    setSelectedCommunity((prevSelectedCommunity) => [
      ...prevSelectedCommunity,
      community.id,
    ]);
    const updatedCommunity = selectedCommunity.map((community) => [
      ...community,
      community.id,
    ]);
    onChange(updatedCommunity);
  };

  const handleDiscardCommunity = (community) => {
    setSelectedCommunity((prevSelectedCommunity) => {
      return prevSelectedCommunity.filter((c) => c.id !== community.id);
    });
    const updatedCommunity = selectedCommunity.filter(
      (c) => c.id !== community.id,
    );
    onChange(updatedCommunity);
  };

  const handleSearchCommunity = (searchedCommunity) => {
    if (!searchedCommunity || searchedCommunity.length === 0) {
      setSearchedCommunity(recommendedCommunity);
      return;
    }
    const searched = recommendedCommunity?.filter((community) =>
      community.name
        .toLowerCase()
        .includes(searchedCommunity.trim().toLowerCase()),
    );
    if (!isEmpty(searched)) {
      setSearchedCommunity(searched);
    }
  };

  console.log('selected community', selectedCommunity);

  return (
    <div className="flex flex-col items-start justify-start gap-4">
      <div className="flex w-full">
        <Search
          placeholder="Search Community"
          onChange={(val) => handleSearchCommunity(val)}
        />
      </div>
      <div className="flex flex-col">
        <Typography variant="body2">COMMUNITY SUPPORTED BY YOU</Typography>
        <Stack
          gap={2}
          direction="row"
          flexWrap="wrap"
          className="max-h-[150px] overflow-y-auto">
          {userProfile?.following?.community?.map((community) => (
            <CardContainer
              key={community.id}
              // onClick={() => handleItemClick(community)}
            >
              <CommunityItem community={community} />
            </CardContainer>
          ))}
        </Stack>
      </div>
      <div className="flex flex-col">
        <Typography variant="body2">MORE COMMUNITY YOU CAN SUPPORT</Typography>
        <Stack
          gap={2}
          direction="row"
          flexWrap="wrap"
          className="max-h-[300px] overflow-y-auto">
          {[
            ...(!isEmpty(searchedCommunity)
              ? searchedCommunity
              : recommendedCommunity),
          ]?.map((community) => (
            <CardContainer
              key={community.id}
              // onClick={() => handleItemClick(community)}
            >
              <CommunityItem
                community={community}
                addCommunity={handleAddCommunity}
                discardCommunity={handleDiscardCommunity}
              />
            </CardContainer>
          ))}
        </Stack>
      </div>
      <div className="flex w-full justify-between gap-4">
        <div className="flex-flow-col">
          <Button
            variant="outlined"
            color="primary"
            className="mt-2"
            onClick={onBack}>
            Back
          </Button>
        </div>
        {true ? (
          <div className="flex-flow-col">
            <Button
              variant="filled"
              color="primary"
              type="submit"
              className="mt-2"
              onClick={onNext}>
              Next
            </Button>
          </div>
        ) : (
          <div className="flex-flow-col">
            <Button
              disabled
              variant="outlined"
              color="primary"
              type="submit"
              className="mt-2"
              onClick={onNext}>
              Next
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default EditProfileNpoStep;
